import { getScribeHttpClients } from '@heidi/api/client';
import { type components } from '@heidi/schema/ml-scribe';

type GetUserNotificationPreferencesResponse =
  components['schemas']['GetUserNotificationPreferencesResponse'];

const http = () => getScribeHttpClients().scribeHttpV2;

/** @domain workspace */
export const getNotificationPreferences = () => {
  return http().get<GetUserNotificationPreferencesResponse>(`/notifications/preferences`);
};
